import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getFormatI18nKey } from 'src/_shared/utils/getI18nKeys';
import { getFormattedPercentage, getFormattedPrice } from 'src/helpers/price.helper';

export type TPriceDetailsModel = typeof PriceDetailsModel;
export type ProductOptionModelInstance = Instance<TPriceDetailsModel>;
export interface IProductOptionModelIn extends SnapshotIn<TPriceDetailsModel> {}
export interface IProductOptionModelInstance extends ProductOptionModelInstance {}

const itemModel = types
  .model({
    discountPercentage: types.optional(types.number, 0),
    discountedTotalPrice: types.optional(types.number, 0),
    format: types.optional(types.string, ''),
    originalTotalPrice: types.optional(types.number, 0),
    quantity: types.optional(types.number, 0),
  })
  .views(self => ({
    get titleKey() {
      return getFormatI18nKey('print', self.format);
    },
    get totalPrice() {
      return getFormattedPrice({ price: self.originalTotalPrice, withCurrency: true });
    },
    get totalDiscountedPrice() {
      return getFormattedPrice({ price: self.discountedTotalPrice, withCurrency: true });
    },
    get discount() {
      return getFormattedPercentage(self.discountPercentage);
    },
  }));

const groupModel = types
  .model({
    groupCode: types.string,
    items: types.array(itemModel),
  })
  .views(self => ({
    get titleKey() {
      return `discounts-tooltip:${self.groupCode}`;
    },
  }));

export const PriceDetailsModel = types
  .model({
    groups: types.optional(types.array(groupModel), []),
    totalItems: types.optional(types.number, 0),
  })
  .views(self => ({}))
  .actions(self => ({}));
